export const getSelectedProductPrimary = ({ current, product, priceModel }) => {
  const result = {
    ...current
  };

  const ctxPriceId = priceModel ? priceModel.id : "";
  const ctxCurrency = priceModel ? priceModel.currency : "";
  const ctxInterval =
    priceModel && priceModel.recurring ? priceModel.recurring.interval : "";

  result.product = product;
  result.price = ctxPriceId;
  result.currency = ctxCurrency;
  result.interval = ctxInterval;

  return result;
};

export const getSelectedPricePrimary = ({ current, price, priceModel }) => {
  const result = {
    ...current
  };

  result.price = price;
  result.currency = priceModel.currency;
  result.interval = priceModel.recurring ? priceModel.recurring.interval : "";

  return result;
};
